module.exports = __webpack_public_path__ + "images/gameMain04.png?ed7f7d82534d4f87a434a92384bf0a5e";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameMain04.png
// module id = 94
// module chunks = 0